<template>
  <el-tooltip :placement="placement" :content="content" popper-class="help-tip__popper">
    <i class="fa fa-info-circle text-muted help-tip__icon"
       role="img" tabindex="0" :aria-label="content"></i>
  </el-tooltip>
</template>

<script>

export default {
  name: 'help-tip',

  props: {

    content: {
      type: String,
      required: true
    },

    placement: {
      type: String,
      default: 'top'
    }

  }

}
</script>

<style scoped>
.help-tip__icon {
  margin-left: 4px;
  font-size: 12px;
  cursor: help;
}
</style>
